import { render, staticRenderFns } from "./controlbarWrapper.vue?vue&type=template&id=5871d434&"
import script from "./controlbarWrapper.vue?vue&type=script&lang=js&"
export * from "./controlbarWrapper.vue?vue&type=script&lang=js&"
import style0 from "./controlbarWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports